import { BadgePill } from '@tymbe/ty-components/indicators';
import AvatarWithInitials from '../../../../components/AvatarWithInitials';

interface ShiftDetailHistoryCardProps {
  date: string;
  time: string;
  title: string;
  badgeVariant?: 'success' | 'warning' | 'error' | 'info';
  badgeText?: string;
  text: string;
  avatarInitials: string;
}

export const ShiftDetailHistoryCard = ({
  date,
  time,
  title,
  badgeVariant = 'info',
  badgeText,
  text,
  avatarInitials,
}: ShiftDetailHistoryCardProps) => {
  return (
    <div className="relative">
      <AvatarWithInitials
        initials={avatarInitials}
        size="lg"
        className="absolute -left-[31px]"
      />
      <div className="rounded-lg bg-white px-4 shadow-sm">
        <div className="text-xs text-secondary-400 text-caption-md">
          {date}, {time}
        </div>
        <div className="text-body-2-sm">{title}</div>
        <div className="mt-2 text-sm text-gray-600 shadow-down-xs border-secondary-100 border-[1px] rounded-2xl p-4">
          {badgeText !== undefined ? (
            <BadgePill variant={badgeVariant} className="w-min mb-1">
              {badgeText}
            </BadgePill>
          ) : null}
          <div className="text-body-2-md font-semibold">{text}</div>
        </div>
      </div>
    </div>
  );
};
